// src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import api from './api/api';
import { AuthProvider } from './context/AuthContext';
import RutaPrivada from './pages/RutaPrivada';

// Páginas públicas
import AdminLoginForm from './pages/AdminLoginForm';

// Layout
import AdminLayout from './components/AdminLayout';

// Páginas privadas
import AccountsPage from './pages/AccountsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminsPage from './pages/AdminsPage';
import ApiUsage from './pages/ApiUsage';
import AdminCompaniesPage from './pages/AdminCompaniesPage';
import Permissions from './pages/Permissions';
import Tenants from './pages/Tenants';
import UserTenants from './pages/UserTenants';
import AdminUserPermissionsPage from './pages/AdminUserPermissionsPage';
import BannedIps from './pages/BannedIps';
import Plans from './pages/Plans';
import Stats from './pages/Stats';
import Logs from './pages/Logs';
import CreaTenant from './pages/CreaTenant';
import ServiceKeysPage from './pages/ServiceKeysPage'
import Scheduler from './pages/Scheduler'

function AppRoutes() {
  const navigate = useNavigate();

  useEffect(() => {
    // Interceptor de respuestas: si recibimos 401, vamos al login
    const interceptor = api.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          // Aquí puedes limpiar tokens o estado de AuthContext si quieres
          navigate('/login', { replace: true });
        }
        return Promise.reject(error);
      }
    );
    return () => api.interceptors.response.eject(interceptor);
  }, [navigate]);

  return (
    <Routes>
      {/* Ruta pública de login */}
      <Route path="/login" element={<AdminLoginForm />} />

      {/* Rutas privadas bajo el mismo layout */}
      <Route
        path="/"
        element={
          <RutaPrivada>
            <AdminLayout />
          </RutaPrivada>
        }
      >
        {/* Redirigir "/" a "/stats" */}
        <Route index element={<Navigate to="stats" replace />} />

        <Route path="accounts" element={<AccountsPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="admins" element={<AdminsPage />} />
        <Route path="api-usage" element={<ApiUsage />} />
        <Route path="companies" element={<AdminCompaniesPage />} />
        <Route path="permissions" element={<Permissions />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="usertenants" element={<UserTenants />} />
        <Route path="user_permissions" element={<AdminUserPermissionsPage />} />
        <Route path="bannedips" element={<BannedIps />} />
        <Route path="plans" element={<Plans />} />
        <Route path="stats" element={<Stats />} />
        <Route path="logs" element={<Logs />} />
        <Route path="tenants/create" element={<CreaTenant />} />
        <Route path="service_keys" element={<ServiceKeysPage />} />
        <Route path="scheduler" element={<Scheduler />} />
      </Route>

      {/* Cualquier otra ruta redirige a login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
